// extracted by mini-css-extract-plugin
export default {"root":"TypingIndicator_root__wm-tr","isScrollAtEnd":"TypingIndicator_isScrollAtEnd__G67fI","isActive":"TypingIndicator_isActive__SIp2j"};